// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1pC5b","title":"ClientReferral_title__33ErQ","itemText":"ClientReferral_itemText__3jlmv"};